export default {
    beforeUpdate(el, binding) {
        const data = binding.value;
        const classes = getClasses(data);
        if (!hasPositionRelative(el)) {
            addPositionRelative(el);
        }
        if (data.active) {
            addOverlay(el, classes);
        }
        else {
            removeOverlay(el);
        }
    },
};
function hasPositionRelative(el) {
    return el.querySelector('.position-relative') !== null;
}
function addPositionRelative(el) {
    el.classList.add('position-relative');
}
function hasOverlay(el) {
    return el.querySelector('.notice-overlay') !== null;
}
function addOverlay(el, classes) {
    if (hasOverlay(el)) {
        return;
    }
    const overlay = document.createElement('div');
    for (const className of classes) {
        overlay.classList.add(className);
    }
    el.appendChild(overlay);
}
function removeOverlay(el) {
    const overlay = el.querySelector('.notice-overlay');
    if (overlay) {
        el.removeChild(overlay);
    }
}
function getClasses(data) {
    const classes = ['notice-overlay'];
    if (data.fade) {
        classes.push('notice-overlay--fade');
    }
    return classes;
}
